window.setLabels = async () => {

  const labels = await getLabels()

  let labels_json = JSON.parse(labels)
  let labels_obj = labels_json.labels

  return labels_obj

}

async function getLabels () {
  try {
    const response = await fetch(`/collections/all?view=labels`)
    let json = await response.json()
    return json
  } catch (error) {
    console.warn(error)
  }
}
